import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/topics", label: "话题广场" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const isHome = pathname === "/";
  const overlay = isHome && !scrolled && !menuOpen;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        overlay ? "bg-transparent" : "bg-background-50/90 backdrop-blur border-b border-background-200/70"
      }`}
    >
      <div className="flex items-center justify-between px-4 md:px-10 h-16 md:h-20">
        <Link to="/" className="flex items-center gap-2.5 shrink-0 cursor-pointer">
          <span className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg md:text-xl"></i>
          </span>
          <span className="leading-tight">
            <span className={`block font-heading font-bold text-lg md:text-xl ${overlay ? "text-background-50" : "text-foreground-950"}`}>
              17吃瓜社区
            </span>
            <span className={`hidden sm:block text-[11px] tracking-wide ${overlay ? "text-background-100/80" : "text-foreground-500"}`}>
              边看边聊 · 观点都能被看见
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  overlay
                    ? isActive
                      ? "text-background-50 bg-background-50/15"
                      : "text-background-100 hover:text-background-50 hover:bg-background-50/10"
                    : isActive
                    ? "text-primary-700 bg-primary-100"
                    : "text-foreground-700 hover:text-primary-700 hover:bg-background-100"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/topics"
            className="ml-2 px-5 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer flex items-center gap-1.5"
          >
            <i className="ri-chat-smile-2-line"></i>
            去聊两句
          </Link>
        </nav>

        <button
          type="button"
          aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((v) => !v)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md cursor-pointer ${
            overlay ? "text-background-50 bg-background-50/15" : "text-foreground-900 bg-background-100"
          }`}
        >
          <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-3-line text-xl"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 pb-5 pt-2">
          <nav className="flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-md text-sm font-medium cursor-pointer ${
                    isActive ? "bg-primary-100 text-primary-700" : "text-foreground-800 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/topics"
              className="mt-2 px-4 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-medium text-center whitespace-nowrap cursor-pointer"
            >
              去聊两句
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}